import type { Attachment } from '@travelity/api/services';

export const fileToBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const result = reader.result as string;
            const commaIndex = result.indexOf(',');
            resolve(result.slice(commaIndex + 1));
        };
        reader.onerror = reject;
    });

export const getImageSize = (file: File) =>
    new Promise<{ width: number; height: number }>((resolve, reject) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        img.onload = () => {
            resolve({ width: img.width, height: img.height });
            URL.revokeObjectURL(objectUrl);
        };
        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('Failed to load image.'));
        };
        img.src = objectUrl;
    });

const getFilenameFromUrl = (url: string): string => {
    const name = url.split('/').pop();
    return name && name.trim().length ? name : 'Image';
};

export const getAttachmentName = (attachment: Attachment): string => {
    if (attachment.name && attachment.name.trim().length) {
        return attachment.name;
    }
    if (attachment.url) {
        return getFilenameFromUrl(attachment.url);
    }
    return 'Image';
};
